import { login, logout, getInfo, loginPhone} from "@/api/login.js";
import {
  getToken,
  setToken,
  removeToken,
  setExpiresIn,
} from "@/utils/cookieUtil.js";

const user = {
  state: {
    token: getToken(),
    name: "",
    permissions: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.userName, userInfo.password, userInfo.domain,userInfo.code,userInfo.uuid)
          .then((res) => {
            let data = res.data;
            setToken(data.access_token);
            commit("SET_TOKEN", data.access_token);
            setExpiresIn(data.expires_in);
            commit("SET_EXPIRES_IN", data.expires_in);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //手机号码登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginPhone(userInfo.phone, userInfo.phoneCode)
          .then((res) => {
            let data = res.data;
            setToken(data.access_token);
            commit("SET_TOKEN", data.access_token);
            setExpiresIn(data.expires_in);
            commit("SET_EXPIRES_IN", data.expires_in);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            if (res.permissions && res.permissions.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit("SET_PERMISSIONS", res.permissions);
            }else{
              commit('SET_PERMISSIONS', ['PERMISSIONS_DEFAULT'])
            }
            commit("SET_NAME", res.userName);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_PERMISSIONS", []);
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearCookie({ commit }){
      commit("SET_TOKEN", "");
      commit("SET_PERMISSIONS", []);
      removeToken();
    }
  },
};

export default user;
